// src/i18n.ts
import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

// Import your translation files
import en from './locales/en/translation.json'
import it from './locales/it/translation.json'

// Initialize i18next
i18n.use(initReactI18next).init({
  resources: {
    en: {
      translation: en
    },
    it: {
      translation: it
    }
  },
  lng: 'it', // Default language
  fallbackLng: 'en', // Fallback language
  interpolation: {
    escapeValue: false // React already escapes by default
  }
})

export default i18n
